// src/pages/CityRedirect.jsx
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CITY_MAP = {
  warszawa: { lat: 52.2319581, lng: 21.0067249, label: "Warszawa, MZ, Polska" },
  krakow:   { lat: 50.0646501, lng: 19.9449799, label: "Kraków, MA, Polska" },
  wroclaw:  { lat: 51.1078852, lng: 17.0385376, label: "Wrocław, DS, Polska" },
  gdansk:   { lat: 54.3520252, lng: 18.6466384, label: "Gdańsk, PM, Polska" },
  poznan:   { lat: 52.406374,  lng: 16.9251681, label: "Poznań, WP, Polska" },
  lodz:     { lat: 51.7592485, lng: 19.4559833, label: "Łódź, ŁD, Polska" },
};

const normalize = (s) =>
  (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const toSlug = (s) =>
  normalize(s).replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

export default function CityRedirect() {
  const { citySlug, categorySegments } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      // 1) Miasto
      const key = normalize(citySlug);
      const city = CITY_MAP[key];
      if (!city) {
        navigate("/", { replace: true });
        return;
      }

      // 2) Kategoria(e) – opcjonalne
      let categoriesParam = "";
      if (categorySegments) {
        // podziel po przecinku, np. "imprezy,koncerty"
        const wanted = categorySegments.split(",").map((s) => s.trim()).filter(Boolean);

        try {
          // pobierz realne kategorie z backendu (id, name)
          const res = await fetch(`${API_BASE}/api/events/categories/`);
          const list = await res.json(); // [{id, name, event_count}, ...] wg Twojego endpointu
          const mapSlugToName = new Map(
            list.map((c) => [toSlug(c.name), c.name])
          );

          const resolved = wanted
            .map((w) => mapSlugToName.get(toSlug(w)))
            .filter(Boolean);

          if (resolved.length) {
            // backend przyjmuje nazwy (u Ciebie w get_queryset obsługujesz names)
            categoriesParam = resolved.join(",");
          }
        } catch {
          // jak nie uda się pobrać, po prostu pomiń kategorie
        }
      }

      // 3) Zachowaj radius z aktualnego URL-a jeśli jest
      const currentSearch = new URLSearchParams(window.location.search);
      const radius = currentSearch.get("radius_km") || "10";

      // 4) Złóż docelowe query
      const params = new URLSearchParams({
        lat: String(city.lat),
        lng: String(city.lng),
        radius_km: radius,
        location_label: city.label,
        sort: "new",
      });
      if (categoriesParam) {
        console.log("Ustawiam kategorie:", categoriesParam);
        // użyj takiego klucza, jaki obsługujesz w backendzie (u Ciebie: "category")
        params.set("category", categoriesParam);
      }

      navigate({ pathname: "/", search: `?${params.toString()}` }, { replace: true });
    })();
  }, [citySlug, categorySegments, navigate]);

  return null;
}
